/**
 * ChartVerdict — one-line "so what?" caption that sits directly
 * under a ROI chart. Small, muted, italic — meant as a five-second
 * verdict a student can grab before drilling into the numbers.
 *
 * Callers pass either:
 *   • a pre-computed `text` string, or
 *   • no text and a `fallback` element (rare; used when data is
 *     missing and we still want a neutral note).
 */
import { Sparkles } from "lucide-react";

export default function ChartVerdict({ text, testId, tone = "neutral" }) {
  if (!text) return null;
  const toneClass =
    tone === "positive"
      ? "text-emerald-800 bg-emerald-50 border-emerald-200"
      : tone === "warning"
        ? "text-amber-900 bg-amber-50 border-amber-200"
        : "text-stone-700 bg-stone-50 border-stone-200";
  return (
    <div
      data-testid={testId || "chart-verdict"}
      className={`mt-2 inline-flex items-start gap-1.5 rounded-md border ${toneClass} px-2.5 py-1.5 text-[12px] leading-snug`}
    >
      <Sparkles className="h-3 w-3 mt-[3px] shrink-0 opacity-70" aria-hidden />
      <span>{text}</span>
    </div>
  );
}
